import { apiFetch } from '@/libs/api'
import { TChangePasswordRequest } from '@/shared-types/generated/TChangePasswordRequest'
import { TLoginRequest } from '@/shared-types/generated/TLoginRequest'
import { TMe } from '@/shared-types/generated/TMe'
import { TPasswordTokenInfo } from '@/shared-types/generated/TPasswordTokenInfo'
import { TSetPasswordRequest } from '@/shared-types/generated/TSetPasswordRequest'

const createAuthAPI = () => ({
    login: (input: TLoginRequest) => apiFetch<TMe>('/auth/login', 'POST', input),
    logout: () => fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/auth/logout`, { method: 'POST', credentials: 'include' }),
    me: () => apiFetch<TMe>('/auth/me'),
    changePassword: (input: TChangePasswordRequest) => apiFetch<{ ok: boolean }>('/auth/change-password', 'POST', input),
    passwordToken: (token: string) => apiFetch<TPasswordTokenInfo>(`/auth/password-token/${encodeURIComponent(token)}`),
    setPassword: (input: TSetPasswordRequest) => apiFetch<{ ok: boolean }>('/auth/set-password', 'POST', input),
})

export default createAuthAPI
